import axiosIns from "@/api/axios";


export const getListFieldApprovalKTT = async (params) => {
    const { token } = params;
    try {
        const response = await axiosIns.get(`/common/idp/list-training?token=${token}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching field approval KTT:', error);
        throw error;
    }
}

export const getListApprovalKTT = async (params) => {
    const { token, page = 1, limit = 10, all = false } = params;
    try {
        const queryParams = {
            token,
            page,
            pageSize: limit,
        };

        if (all) {
            queryParams.all = true;
        }

        const response = await axiosIns.get('/common/idp/submitted-learnings', {
            params: queryParams
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching approval KTT:', error);
        throw error;
    }
}

export const approveIDPByKTT = async (params) => {
    const { token, ids = [] } = params;
    try {
        const response = await axiosIns.post('/common/idp/ktt/approve', {
            ids,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error approving IDP by KTT:', error);
        throw error;
    }
}

export const rejectIDPByKTT = async (params) => {
    const { token, ids = [], reason = '' } = params;
    try {
        const response = await axiosIns.post('/common/idp/ktt/reject', {
            ids,
            reason,
        }, {
            params: {
                token,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error rejecting IDP by KTT:', error);
        throw error;
    }
}
